import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

interface AddAdminParams {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  fullName: string;
  role?: string;
  district_id: number;
}

export async function addAdmin({
  email,
  password,
  firstName,
  lastName,
  fullName,
  role = "district_admin",
  district_id,
}: AddAdminParams): Promise<{ error: string | null }> {
  const { error } = await supabase.functions.invoke("addAdmin", {
    body: {
      email,
      password,
      firstName,
      lastName,
      fullName,
      role,
      district_id,
    },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return { error: errorMessage.error };
  }

  return { error: error?.message || null };
}
